export default __webpack_public_path__ + "static/media/Plissee 22 mm seitlich.5e8da7be.jpg";